import { Flex, Spinner } from '@podiumhq/design-system';
import { fullPageCenterContentWrapperStyles } from 'styles';

const FullScreenSpinner = ({
  children,
  loadingText,
  spinnerProps = {},
  textProps,
  ...flexProps
}) => (
  <Flex {...fullPageCenterContentWrapperStyles} {...flexProps}>
    <Spinner {...spinnerProps} />
    {children}
  </Flex>
);

export default FullScreenSpinner;
